import HttpService from "./htttp.service";

class LanguagesService {
  translate = async (data) => {
    const endpoint = "languages/translate";
    return await HttpService.post(endpoint, data);
  };

  getMultipleLanguages = async (query, cancelToken) => {
    const endpoint = "languages";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  getMultipleExpressions = async (languageId, query, cancelToken) => {
    const endpoint = `languages/${languageId}/expressions`;
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createLanguage = async (data) => {
    const endpoint = "languages";
    return await HttpService.post(endpoint, data);
  };

  removeLanguage = async (languageId) => {
    const endpoint = `languages/${languageId}`;
    return await HttpService.delete(endpoint);
  };

  updateLanguage = async (languageId, data) => {
    const endpoint = `languages/${languageId}`;
    return await HttpService.put(endpoint, data);
  };

  createExpression = async (languageId, data) => {
    const endpoint = `languages/${languageId}/expressions`;
    return await HttpService.post(endpoint, data);
  };

  removeExpression = async (languageId, expressionId) => {
    const endpoint = `languages/${languageId}/expressions/${expressionId}`;
    return await HttpService.delete(endpoint);
  };

  updateExpression = async (languageId, expressionId, data) => {
    const endpoint = `languages/${languageId}/expressions/${expressionId}`;
    return await HttpService.put(endpoint, data);
  };
}

export default new LanguagesService();
